export const path_to_bugs = "./toi/bugs/"

export class Sections {
    static Landing = 0;
    static Enter = 1;
    static Gallery = 2
}

export class Stills {
    static EnterBGVideo = "./toi/enter_bg_video_still.png";
}

export class Icons {
    static EnterButton = "./toi/enter_default.png"
    static EnterButtonHover = "./toi/enter_hover.png"
    static EnterButtonLoading = "./toi/enter_loading.gif"
}

export class Text {
    static AboutFirstLine =
        <p>
            ‘Identity is not an object, it's a process with addresses for the different directions in which it moves’
            <i> - Lynn Margulis</i>
        </p>
    
    static About = [
        // <p>
        //     ‘Identity is not an object, it's a process with addresses for the different directions in which it moves’
        //     <i> - Lynn Margulis</i>
        // </p>,
        <p>
            <span>Microbial Sex Video Comic</span> is a series of videos to worm through based around different types of microbial
            sex. The project emerged through a process of embodied and visual responses produced as part of the
            collective’s transdisciplinary dialogue. Members of the collective ingested and transformed each other's
            references, materials and improvisations to cultivate a pool of interrelated elements that multiple
            entangled worlds birthed through. The world of <span>Microbial Sex Video Comic</span> is composed of porous components;
            footage captured in Kielder forest, Toi Guy’s body as a walking community, digital materials produced by
            Ella Yolande and sound composed by Ande Clock and Mia Windsor.
        </p>,
        <p>
            There’s feelings of yumminess, creepiness and sensuality to melting into a mossy forest that arose through
            filming and editing. The comic is proposing the possibility of these sensations as part of the microbial
            experience, beyond anthropocentric indulgence, since we are not human all the way through. These responses
            can be seen as sensory keys used to decode the way humans associate with organic matter.
        </p>,
    ]
}